import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import './MainYoutubeStaticContainer.scss';

export const MainYoutubeStaticContainer = () => {
    return (
        <Container className='youtube-container' fluid>
            <h1 className='notice_title'>MÍDIA</h1>

            <Row className='youtube-container-row one-video'>
                <Col className='video-wrapper'>
                    <iframe
                        title='aYgiZqyzcRk'
                        width='100%'
                        src='https://www.youtube.com/embed/aYgiZqyzcRk?feature=oembed'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        allowFullScreen
                    ></iframe>
                </Col>
            </Row>

            <Row className='youtube-container-row two-videos'>
                <Col className='video-wrapper'>
                    <iframe
                        title='jkFbyx1QN6U'
                        src='https://www.youtube.com/embed/jkFbyx1QN6U?feature=oembed'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        allowFullScreen
                    ></iframe>
                </Col>
                <Col className='video-wrapper'>
                    <iframe
                        title='HMWr8Nn6e8'
                        src='https://www.youtube.com/embed/-HMWr8Nn6e8?feature=oembed'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        allowFullScreen
                    ></iframe>
                </Col>
            </Row>
        </Container>
    );
};
